import { getPostLoginHomePath } from "util/v3UxConfig";
import { resolveEmbeddedV3GoBackPath } from "util/v3ShellLayoutSync";

export const ADD_LIMIT_PREV_PATH_STATE_KEY = "prevPath";

/**
 * @param {import("history").Location|{ state?: object }|undefined|null} location
 * @returns {string|undefined}
 */
export function getPrevPathFromLocation(location) {
    const p = location?.state?.[ADD_LIMIT_PREV_PATH_STATE_KEY];
    return typeof p === "string" && p.startsWith("/") ? p : undefined;
}

/**
 * @param {string} prevPath pathname absoluto del origen
 * @returns {{ pathname: string, state?: object }}
 */
export function buildAddLimitRequestLocation(prevPath) {
    return {
        pathname: "/v2/addlimitrequest",
        state: prevPath ? { [ADD_LIMIT_PREV_PATH_STATE_KEY]: prevPath } : undefined,
    };
}

/**
 * @param {string|undefined} prevPath
 * @returns {{ pathname: string, state?: object }}
 */
export function buildAddLimitRequestConfirmationLocation(prevPath) {
    return {
        pathname: "/addlimitrequestconfirmation",
        state: prevPath ? { [ADD_LIMIT_PREV_PATH_STATE_KEY]: prevPath } : undefined,
    };
}

/**
 * @param {import("history").Location|{ state?: object }|undefined|null} location
 * @param {string|undefined|null} [storedPrevPath]
 * @returns {string}
 */
export function resolveAddLimitGoBackTarget(location, storedPrevPath) {
    const fromState = getPrevPathFromLocation(location);
    if (fromState) {
        return fromState;
    }
    if (typeof storedPrevPath === "string" && storedPrevPath.startsWith("/")) {
        return storedPrevPath;
    }
    return getPostLoginHomePath(true);
}

/**
 * prevPath explícito solo si viene en la navegación actual (no Redux: puede quedar de un flujo anterior).
 *
 * @param {import("history").Location|{ state?: object }|undefined|null} location
 * @returns {boolean}
 */
export function hasExplicitAddLimitPrevPath(location) {
    return Boolean(getPrevPathFromLocation(location));
}

/**
 * Back del comprobante: prevPath en location.state (p. ej. post-envío); si no, lastHref (/transactions/list).
 *
 * @param {import("history").Location|{ state?: object }|undefined|null} location
 * @param {string|undefined|null} [lastHrefPathname]
 * @returns {string}
 */
export function resolveAddLimitTicketGoBackTarget(location, lastHrefPathname) {
    if (lastHrefPathname === "/transactions/list" || lastHrefPathname === "/pendingTransaction/list") {
        return lastHrefPathname;
    }
    const fromState = getPrevPathFromLocation(location);
    if (fromState) {
        return fromState;
    }
    return resolveEmbeddedV3GoBackPath("/payments/payDebin", lastHrefPathname);
}

/**
 * Navegación al comprobante tras `redirectFinished`: solo propaga `prevPath` en envío nuevo del flujo.
 * Desde `/transaction/:id` (historial) no debe reutilizar `prevPath` persistido en Redux.
 *
 * @param {boolean|undefined} newTransaction
 * @param {string|undefined|null} storedPrevPath
 * @returns {{ pathname: string, state?: object }}
 */
export function buildAddLimitFinishedConfirmationLocation(newTransaction, storedPrevPath) {
    const prevPath =
        newTransaction && typeof storedPrevPath === "string" && storedPrevPath.startsWith("/")
            ? storedPrevPath
            : undefined;
    return {
        pathname: "/addlimitrequest/confirmation",
        state: prevPath ? { [ADD_LIMIT_PREV_PATH_STATE_KEY]: prevPath } : undefined,
    };
}
